import reducer from "./reducer";
export { default as BankSettings } from "./components/index";
export { default as bankSettingsReducerName } from "./constants";
export default reducer;
